export const isUndefinedOrNull = (value?: any) => value == null

/**
 * Verifica se um valor é estritamente `null`, substituindo o `isNull` do lodash.
 *
 * Diferente de {@link isUndefinedOrNull} (que também considera `undefined`), aqui apenas `null`
 * retorna `true` — equivalente a `value === null`.
 */
export const isNull = (value?: any) => value === null

/**
 * Verifica se um valor está "vazio", substituindo o `isEmpty` do lodash por implementação nativa.
 *
 * Considera vazio: `null`, `undefined`, string ou array sem elementos, objeto sem chaves próprias e
 * `Map`/`Set` sem entradas. Assim como no lodash, números e booleanos são sempre considerados vazios,
 * pois não possuem propriedades enumeráveis.
 */
export function isEmpty(value: unknown): boolean {
  if (value == null) return true
  if (typeof value === 'string' || Array.isArray(value)) return value.length === 0
  if (value instanceof Map || value instanceof Set) return value.size === 0
  if (typeof value === 'object') return Object.keys(value).length === 0
  return true
}
